import Muuri from "muuri";

export default ({ init = () => null, dragEnd = () => null, options, ...others } = {}) => {
    let instance;

    return {
        ...others,
        muuri() {
            return instance;
        },
        reorder(ids) {
            this.muuri().sort(
                (itemA, itemB) => {
                    const elA = itemA.getElement();
                    const elB = itemB.getElement();

                    const indexA = ids.findIndex((id) => id == elA.dataset.id);
                    const indexB = ids.findIndex((id) => id == elB.dataset.id);

                    return indexA - indexB;
                },
                { layout: true },
            );
        },
        refresh: Alpine.debounce(function () {
            Array.from(this.$el.children).forEach((el) => {
                let item = this.muuri().getItem(el);

                if (!item) {
                    item = this.muuri().add([el], {
                        index: 0,
                        active: false,
                        layout: false,
                    });

                    this.muuri().show(item, {
                        syncWithLayout: true,
                        layout: false,
                    });
                }
            });

            this.muuri().refreshItems();
            this.muuri().layout();
        }, 150),
        remove(el, callback = () => null) {
            const item = this.muuri().getItem(el);

            this.muuri().hide([item], {
                onFinish: (items) => {
                    callback(el.dataset.id);
                },
            });
        },
        initMuuri() {
            const _this = this;

            instance = new Muuri(this.$el, {
                ...options,
                layoutDuration: 200,
                dragEnabled: true,
                dragStartPredicate: {
                    distance: 2,
                    delay: 0,
                },
            });

            instance.on("dragEnd", (item, event) => {
                dragEnd.call(_this);
            });

            this.$wire.hook("morph.updated", ({ el, component }) => {
                if (el.classList.contains("muuri-item")) {
                    _this.refresh();
                }
            });
        },
        init() {
            this.$nextTick(() => {
                this.initMuuri();
            });

            init.call(this);
        },
        destroy() {
            if (instance) {
                instance.destroy();
            }
        },
    };
};
